import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth/AppAuthContext";
import { Roles } from "../firestore/Types/PermissionSchema";
import { AdminLayout } from "./AdminLayout";
import { TutorPageLayout } from "./TutorPageLayout";
import { UserPageLayout } from "./UserPageLayout";

export function LoggedInLayoutSelector({ children }: { children: React.ReactNode }) {
    const { userLoggedIn, permission, currentUser } = useAuth();

    const navigate = useNavigate();

    // uncomment for production
    if (currentUser && !currentUser.emailVerified) {
        navigate('/verify-email', { replace: true });
    }

    if (userLoggedIn === false || currentUser === null) {
        navigate('/login', { replace: true });
    }

    if (permission.Role === Roles.Tutor) {
        return (
            <TutorPageLayout>
                {children}
            </TutorPageLayout>
        );
    }

    if (permission.Role === Roles.User) {
        return (
            <UserPageLayout>
                {children}
            </UserPageLayout>
        );
    }

    if (permission.Role === Roles.Admin) {
        return (
            <AdminLayout>
                {children}
            </AdminLayout>
        );
    }

    return (
        <>
            {children}
        </>
    );
}